export var VELT_SDK_VERSION = '5.0.2-beta.31';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '5.0.2-beta.31': 'sha384-5O4aQGXMlfDw5Fjpqlx3lSqOIKqigAy+vpKuCyR0RpuMrBgm1Ich/+zN2IcBp1sZ',
};
